import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fa8c97d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "row first" }
const _hoisted_3 = { class: "date" }
const _hoisted_4 = { class: "row second" }
const _hoisted_5 = { class: "type" }
const _hoisted_6 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "row-wrapper",
    role: "link",
    tabindex: "0",
    "aria-label": `${$props.application?.title ?? ''} 상세 페이지로 이동`,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickRow', $setup.props.application))),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('onClickRow', $setup.props.application)), ["prevent"]), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('onClickRow', $setup.props.application)), ["prevent"]), ["space"]))
    ]
  }, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode($setup["NewRouteStatusChip"], {
        statusCode: $props.application?.statusCode ?? '',
        statusName: $props.application?.statusName ?? ''
      }, null, 8 /* PROPS */, ["statusCode", "statusName"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.usePeriodDisplayText), 1 /* TEXT */)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString($setup.lineTypeDisplayText), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_6, _toDisplayString($props.application?.title ?? ""), 1 /* TEXT */)
    ])
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}